// src/layouts/Pages/PageHeader/CardHeaderColumns/items/phone.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { parsePhoneToDisplay, returnOnlyNumbers } from 'utils/helpers';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const phoneItem = record => {
  const phone =
    record?.phone?.displayValue || parsePhoneToDisplay(record?.phone?.value || record?.phone);
  const phoneNational = record?.phone?.national || phone;
  const hasWhatsApp = record?.phone?.hasWhatsApp === true;
  const phoneNumber = returnOnlyNumbers(phone);

  // Handle click: copy to clipboard, then show action option
  const handleClick = () => {
    appService.handleCopyToClipboard(phoneNumber);

    if (hasWhatsApp) {
      // Show notification with WhatsApp option
      appService.notification({
        flag: 'success',
        icon: <WhatsAppOutlined style={{ color: '#25D366' }} />,
        title: 'number_copied_success',
        description: translateX('open_whatsapp_question', { phone: phoneNational }),
        noTranslateDescription: true,
        duration: 0,
        actions: [
          { text: 'no', type: 'default' },
          { text: 'yes', type: 'primary', onClick: () => window.open(`https://wa.me/${phoneNumber}`, '_blank') },
        ],
      });
    } else {
      // Show notification with call option
      appService.notification({
        flag: 'success',
        icon: <PhoneOutlined />,
        title: 'number_copied_success',
        description: translateX('call_phone_question', { phone: phoneNational }),
        noTranslateDescription: true,
        duration: 0,
        actions: [
          { text: 'no', type: 'default' },
          { text: 'yes', type: 'primary', onClick: () => window.open(`tel:${phoneNumber}`, '_self') },
        ],
      });
    }
  };

  return {
    key: 'phone',
    icon: hasWhatsApp ? <WhatsAppOutlined style={{ color: '#25D366' }} /> : <PhoneOutlined />,
    label: phone,
    tooltipText: translateX(hasWhatsApp ? 'whatsapp' : 'phone'),
    tooltipPlacement: 'right',
    onClick: phone ? handleClick : null,
  };
};

export default phoneItem;
